/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Component, Inject, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DeviceConfiguration } from 'src/app/models/device-configuration';
import { MatIconModule } from '@angular/material/icon';

export interface DeviceConfigDiaglog {
  identifier: string;
  configuration: DeviceConfiguration;
}
@Component({
  selector: 'app-device-config-dialog',
  templateUrl: './config-dialog.component.html',
  styleUrls: ['./config-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogModule,
    FormsModule,
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    AngularSvgIconModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatButtonModule,
  ],
})
export class ConfigDialogComponent implements OnInit {
  identifier = this.data.identifier;
  configuration = this.data.configuration;
  deleteClicked = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DeviceConfigDiaglog, private fb: FormBuilder) {}

  ngOnInit(): void {}

  deleteDisabled(): boolean {
    return false;
  }
}
